import * as React from 'react';
import MDButton from 'components/MDButton';
import MDBadge from 'components/MDBadge';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Icon from "@mui/material/Icon";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

/* eslint-disable react/prop-types */
export default function ModalDialog({onCloseModalClick, onLeftButtonClick, onRightButtonClick, title, rightTitle, content, leftButton, rightButton}) {

  const handleCloseModalClick = () => {
    onCloseModalClick();
  }

  const handleCloseOfferClick = () => {
    onRightButtonClick();
  }

  const handleCancelOfferClick = () => {
    onLeftButtonClick();
  }

  return (
    <>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={true}
      >
        <MDBox display="flex" justifyContent="space-between" alignItems="center">
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {title}
          </DialogTitle>
          <MDBox display="flex" alignItems="center">
            {rightTitle &&
              <MDBadge badgeContent="System" color="error" variant="gradient" size="md" />
            }
          <IconButton
            aria-label="close"
            onClick={handleCloseModalClick}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
              <CloseIcon />
          </IconButton>
          </MDBox>
        </MDBox>
        <DialogContent dividers>
          {content}
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-around" }}>
          {leftButton &&
          <MDButton component="a" href="#" onClick={handleCancelOfferClick}>
          <MDBadge badgeContent={leftButton} color='error' variant="gradient" size="md" />
          </MDButton>
          }
          {rightButton && 
          <MDButton component="a" href="#" onClick={handleCloseOfferClick}>
          <MDBadge badgeContent={rightButton} color='success' variant="gradient" size="md" />
          </MDButton>
          }      
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}